import React from 'react'
import styles from './pagoT1.module.sass'
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export function ViewTP(props){
    const {
        codigo,
        isMobile,
        handleFinalizar
    } = props

    return(
        <div className={styles?.contentConsulta}>

            <div className={styles?.contCardTP}>
                <div className={styles?.sectionInterna}>
                    <div className={styles?.creditoCS_white_logo}></div>
                    <div className={styles?.textWhite}>
                        <h1>¡Gracias!</h1>
                        <h2>Tu pago se realizo con éxito</h2>
                    </div>
                    <div className={styles?.textWhiteSmall}>
                        <p>Se verá reflejado en un máximo de 48 hrs.</p>
                        <p>Puede darle seguimiento en el banco con el siguiente número de autorización.</p>
                    </div>
                </div>

                <div className={`${styles?.cardCreditoStyle} ${styles?.cardCreditoMessage}`}>
                    <div className={styles?.iconTP}></div>
                    <h3>Anota el numero de operación para cualqueir aclaración</h3>
                    <p>Captura esta pantalla o anota tu número de folio</p>
                    <div className={styles?.codeBorder}>{codigo}</div>
                </div>

                <div className={styles?.boxBtnFinalizar}>
                    <button onClick={handleFinalizar}>Continuar</button>
                </div>
            </div>
        </div>
    )
}